export default __webpack_public_path__ + "static/media/ava-frame.38b02c24.svg";